import { keymap } from 'prosemirror-keymap';
import type { EditorView } from 'prosemirror-view';

import { WysiwygShortcuts } from '@core/wysiwyg-legacy';

import type { BoldSchema } from './bold-mark';
import type { EditorButton, EditorMode, RtPMPlugin } from '../../../editor/types';
import { MarkService, toggleMark } from '../../../helpers/mark-base';
import { DEFAULT_KEYMAP_INPUTRULE_PRIORITY, metaKey } from '../../../helpers/utils';

export class BoldService<S extends BoldSchema> extends MarkService<S> {}

export class BoldPlugin implements RtPMPlugin {
  public api: {
    boldService: BoldService<BoldSchema>;
  };
  public buttons = {
    toggleBold: <EditorButton>{
      icon: 'format-bold',
      tooltipText: 'wysiwyg.bold',
      tooltipShortcut: WysiwygShortcuts.Bold(metaKey),
      isActive: (...args) => this.api.boldService.isActive(...args),
      run: (state, dispatch) => {
        this.api.boldService.toggle(state, dispatch);
        this.editorView.focus();
      },
    },
  };

  private editorView: EditorView;

  public beforeInit(mode: EditorMode, schema: BoldSchema) {
    this.api = {
      boldService: new BoldService(schema.marks.strong),
    };
  }

  public afterInit(mode: EditorMode, editorView: EditorView) {
    this.editorView = editorView;
  }

  public getNativeEditorPlugins(schema: BoldSchema) {
    return [
      { priority: DEFAULT_KEYMAP_INPUTRULE_PRIORITY, plugin: keymap(this.getKeyBindings(schema)) },
    ];
  }

  private getKeyBindings(schema: BoldSchema) {
    return {
      'Mod-B': toggleMark(schema.marks.strong),
      'Mod-b': toggleMark(schema.marks.strong),
    };
  }
}
